import { Header } from 'react-frontier';

var Notifications =()=>{
	return <div className="team-check-screen">
		<Header text="Avisos" />
	</div>;
};

export default Notifications;
